import React, { useState } from "react";
import { MapPin } from "lucide-react";
import { SiteDetails } from "../../data/sitelocations";
import MapPreview from "./MapPreview";

import { useTheme } from "../ThemeContext";

interface LocationButtonProps {
  placeName: string;
  siteInfo: SiteDetails | null;
}

const LocationButton: React.FC<LocationButtonProps> = ({ placeName, siteInfo }) => {
  const { isDarkMode } = useTheme();
  const [showMapPreview, setShowMapPreview] = useState(false);

  // Default site info for username-based site codes
  const defaultSiteInfo: SiteDetails = {
    location: "Bengaluru, Karnataka",
    coordinates: { lat: 12.9716, lon: 77.5946 },
    displayName: "Bengaluru, Karnataka - AXON",
    gmapsUrl: "https://maps.google.com/?q=12.9716,77.5946",
    mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124406.88371302825!2d77.52026569726562!3d12.9715987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e897e09202!2sBengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1719416400000!5m2!1sen!2sin" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'
  };

  // Use default site info if siteInfo is null (for username-based site codes)
  const activeSiteInfo = siteInfo || defaultSiteInfo;

  const handleOpenMap = () => {
    if (activeSiteInfo?.gmapsUrl) {
      window.open(activeSiteInfo.gmapsUrl, "_blank", "noopener,noreferrer");
    }
  };

  // Always show location button - don't return null

  return (
    <div 
      className="relative rounded-r-2xl"
      style={{ zIndex: 20000 }}
      onMouseEnter={() => setShowMapPreview(true)}
      onMouseLeave={() => setShowMapPreview(false)}
    >
      <button
        className={`flex items-center gap-1.5 pl-4 pr-4 ${isDarkMode ? 'bg-slate-800/80 hover:bg-slate-700/80' : 'bg-white/70 hover:bg-white/90'} transition-colors h-full rounded-r-2xl`}
        title="Hover to preview location"
        type="button"
      >
        <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full ${isDarkMode ? 'bg-amber-950/40 text-amber-300 border border-amber-900/40' : 'bg-gradient-to-r from-orange-50 to-amber-50 text-amber-700 shadow'} text-sm header-light-text max-w-[11rem] truncate`} style={{ fontWeight: '300 !important', fontFamily: 'IBM Plex Sans, sans-serif !important' }}>
          <MapPin className="w-4 h-4 text-orange-500" />
          <span className={`truncate header-light-text ${isDarkMode ? 'text-amber-300' : 'text-amber-700'}`} style={{ fontWeight: '300 !important', fontFamily: 'IBM Plex Sans, sans-serif !important' }}>{placeName}</span>
        </span>
      </button>

      {showMapPreview && (
        <MapPreview
          siteInfo={activeSiteInfo}
          onOpenMap={handleOpenMap}
          onClose={() => setShowMapPreview(false)}
        />
      )}
    </div>
  );
};

export default LocationButton;
